import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChatBubbleLeftEllipsisIcon, BookOpenIcon, ClockIcon } from '@heroicons/react/24/outline';
import { useHelpCentre } from '../../contexts/HelpCentreContext';
import HelpChat from './HelpChat';
import HelpBrowse from './HelpBrowse';
import HelpHistory from './HelpHistory';

// Ask / Guides / Questions — the same three tabs in the slide-over panel
// (HelpButton) and on the Help page.
export default function HelpCentre({ onNavigate, fill = true }) {
  const { t } = useTranslation();
  const { tab, setTab } = useHelpCentre();
  const tabs = [
    { key: 'ask', label: t('admin:help.tabs.ask', 'Ask'), Icon: ChatBubbleLeftEllipsisIcon },
    { key: 'browse', label: t('admin:help.tabs.browse', 'Guides'), Icon: BookOpenIcon },
    { key: 'history', label: t('admin:help.tabs.history', 'Questions'), Icon: ClockIcon },
  ];
  return (
    <div className={`flex flex-col min-h-0 ${fill ? 'h-full' : ''}`}>
      <div className="flex gap-1 border-b border-gray-100 mb-3 flex-shrink-0">
        {tabs.map(({ key, label, Icon }) => (
          <button
            key={key} type="button" onClick={() => setTab(key)}
            className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-b-2 -mb-px ${tab === key ? 'border-brand-600 text-brand-700' : 'border-transparent text-gray-500 hover:text-gray-800'}`}
          >
            <Icon className="h-4 w-4" />{label}
          </button>
        ))}
      </div>
      <div className={`min-h-0 ${fill ? 'flex-1' : ''} ${tab === 'ask' ? '' : 'overflow-y-auto'}`}>
        {tab === 'ask' && <HelpChat onNavigate={onNavigate} />}
        {tab === 'browse' && <HelpBrowse onNavigate={onNavigate} />}
        {tab === 'history' && <HelpHistory onNavigate={onNavigate} />}
      </div>
    </div>
  );
}
